import { v } from '../koko-framework/shorthand'

export const CAESAR = {
    name: 'CAESAR CIPHER',
    view: 'caesarcipherview',
    successMessage: 'You successfully decoded the secret message\nwritten in the Caesar cipher.',
    time: 600,
};
export const PIGPEN = {
    name: 'PIG PEN',
    view: 'pigpenview',
    successMessage: 'You successfully decoded the secret message\nwritten in the Pigpen cipher.',
    time: 420,
};
export const FREQUENCY = {
    name: 'FREQUENCY ANALYSIS',
    view: 'frequencyanalysisview',
    successMessage: 'You successfully decoded the secret message\nusing frequency analysis.',
    time: 900,
};

export const GAME_ORDER = [PIGPEN, CAESAR, FREQUENCY];

export class GameModel {
    currentGame = 0;
    gameScores = null;

    // this is a little bit controller-y, but for the sake of 4 functions we'll leave it here for now
    reset() {
        this.currentGame = 0;
        this.gameScores = [0, 0, 0];
    }

    setGameScore(score) {
        if (this.gameScores[this.currentGame] <= score) {
            this.gameScores[this.currentGame] = score;
        }
    }

    showCurrentGame = () => {
        v.get(GAME_ORDER[this.currentGame].view).transitionIn();
    }

    nextGame() {
        v.get(GAME_ORDER[this.currentGame].view).transitionOut();
        /*
        this.currentGame++;
        if (this.currentGame > GAME_ORDER.length - 1) {
            this.currentGame = GAME_ORDER.length - 1;
        } else {
            setTimeout(this.showCurrentGame, 400);
        }
        */
        if (this.currentGame < GAME_ORDER.length - 1) {
            setTimeout(v.get('levelselect').transitionIn, 400);
        } else {
            setTimeout(v.get('thanksforplaying').transitionIn, 400);
        }
    }

    quitGame = () => {
        v.get(GAME_ORDER[this.currentGame].view).transitionOut();
        setTimeout(v.get('mainmenu').transitionIn, 400);
    }
}

const gameState = new GameModel();
export { gameState as default };